import { render, staticRenderFns } from "./GiftButton.vue?vue&type=template&id=6b93b609&scoped=true&"
import script from "./GiftButton.vue?vue&type=script&lang=js&"
export * from "./GiftButton.vue?vue&type=script&lang=js&"
import style0 from "./GiftButton.vue?vue&type=style&index=0&id=6b93b609&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b93b609",
  null
  
)

export default component.exports